import { TrendingDown, TrendingUp } from 'lucide-react';
import type { ReactNode } from 'react';
import { formatPercent } from '../formats';

export function Kpi({ label, value, sub, change }: {
  label: string;
  value: ReactNode;
  sub?: string;
  /** Percentage change against the previous period; null when there is none. */
  change?: number | null;
}) {
  const up = (change ?? 0) > 0;

  return (
    <div className="card p-4">
      <p className="text-[11px] font-medium uppercase tracking-wide text-ink-500 dark:text-ink-400">
        {label}
      </p>
      <p className="mt-1.5 text-2xl font-semibold tabular-nums text-ink-900 dark:text-paper-50">
        {value}
      </p>
      <div className="mt-1 flex items-center gap-2 text-xs">
        {sub && <span className="text-ink-500 dark:text-ink-400">{sub}</span>}
        {change !== null && change !== undefined && (
          <span
            className={`flex items-center gap-0.5 font-medium ${
              up
                ? 'text-emerald-600 dark:text-emerald-400'
                : 'text-red-600 dark:text-red-400'
            }`}
          >
            {up
              ? <TrendingUp className="h-3 w-3" aria-hidden />
              : <TrendingDown className="h-3 w-3" aria-hidden />}
            {formatPercent(change)}
          </span>
        )}
      </div>
    </div>
  );
}

export function KpiGrid({ children }: { children: ReactNode }) {
  return <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">{children}</div>;
}
